import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { accountManagerDashboardFeatureKey, reducer } from './reducers/account-managers-dashboard.reducer';
import { AccountManagerDashboardEffects } from './effects/account-managers-dashboard.effects';
import { EnvironmentProviders } from '@angular/core';

export const provideAccountManagersDashboardStore = (): EnvironmentProviders[] => [
    provideState(accountManagerDashboardFeatureKey, reducer),
    provideEffects(AccountManagerDashboardEffects)
];
